import { DeleteOutlined, DownOutlined, EditOutlined, IdcardOutlined, UserAddOutlined } from '@ant-design/icons';
import { Button, Dropdown, Menu, Space } from 'antd';
import { useTranslation } from 'react-i18next';
import { type UserGroupSpecsFragment } from '../../../api/fragments/UserGroupSpecs';
import useDeleteUserGroup from './useDeleteUserGroup';
import { useAddDealerDrawer } from './UserGroupAddDealerDrawer';
import { useAddUserDrawer } from './UserGroupAddUserDrawer';
import { useUpdateUserGroupDrawer } from './UserGroupUpdateDrawer';

export type UserGroupActionsProps = { userGroup: UserGroupSpecsFragment };

const UserGroupActions = ({ userGroup }: UserGroupActionsProps) => {
    const { t } = useTranslation(['userGroupDetails']);
    const addUserDrawer = useAddUserDrawer(userGroup);
    const updateUserGroupDrawer = useUpdateUserGroupDrawer(userGroup);
    const addDealerDrawer = useAddDealerDrawer(userGroup);
    const deleteUserGroup = useDeleteUserGroup(userGroup.id);

    const items = [
        {
            label: t('userGroupDetails:mainActionButtons.updateSpecs'),
            key: 'updateSpecs',
            icon: <EditOutlined />,
            onClick: updateUserGroupDrawer.open,
        },
        {
            label: t('userGroupDetails:mainActionButtons.addUsers'),
            key: 'addUsers',
            icon: <UserAddOutlined />,
            onClick: addUserDrawer.open,
        },
        {
            label: t('userGroupDetails:mainActionButtons.addDealers'),
            key: 'addDealers',
            icon: <IdcardOutlined />,
            onClick: addDealerDrawer.open,
        },
        {
            label: t('userGroupDetails:mainActionButtons.delete'),
            key: 'delete',
            icon: <DeleteOutlined />,
            onClick: deleteUserGroup,
            danger: true,
        },
    ];

    if (!items.length) {
        return null;
    }

    return (
        <>
            <Dropdown overlay={<Menu items={items} />}>
                <Button type="primary">
                    <Space>
                        <span>{t('userGroupDetails:mainActionButtons.actions')}</span>
                        <DownOutlined />
                    </Space>
                </Button>
            </Dropdown>
            {addUserDrawer.render()}
            {updateUserGroupDrawer.render()}
            {addDealerDrawer.render()}
        </>
    );
};

export default UserGroupActions;
